import React, { useState, useEffect } from "react";
import "../../Styles/HomeComponentsStyles/StocksPortion.css";
import DoneIcon from "@mui/icons-material/Done";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import { useNavigate } from "react-router-dom";
import StockBox from "./StockBox";

const StocksPortion = ({ theme }) => {
  const navigate = useNavigate();
  const [amount, setAmount] = useState(18);
  const [stocks, setStocks] = useState([
    { symbol: "AAPL", company: "Apple Inc.", marketCap: "2.62T" },
    { symbol: "MSFT", company: "Microsoft Corp.", marketCap: "2.09T" },
    { symbol: "AMZN", company: "Amazon.com Inc.", marketCap: "931.11B" },
    { symbol: "JNJ", company: "Johnson ", marketCap: "459.23B" },
    { symbol: "NVDA", company: "NVIDIA Corp", marketCap: "454.07B" },
    { symbol: "V", company: "Visa,Inc.", marketCap: "438.82" },
    { symbol: "WMT", company: "Walmart Inc.", marketCap: "361.97" },
    { symbol: "MA", company: "Mastercard Inc.", marketCap: "343.89B" },
    { symbol: "PFE", company: "Pfizer Inc.", marketCap: "283.41B" },
    { symbol: "PEP", company: "Pepsico Inc.", marketCap: "241.46B" },
    { symbol: "AMZN", company: "Amazon.com Inc.", marketCap: "931.11B" },
    { symbol: "JNJ", company: "Johnson", marketCap: "459.23B" },
    { symbol: "NVDA", company: "NVIDIA Corp", marketCap: "454.07B" },
    { symbol: "V", company: "Visa,Inc.", marketCap: "438.82" },
    { symbol: "WMT", company: "Walmart Inc.", marketCap: "361.97" },
    { symbol: "MA", company: "Mastercard Inc.", marketCap: "343.89B" },
    { symbol: "PFE", company: "Pfizer Inc.", marketCap: "283.41B" },
    { symbol: "PEP", company: "Pepsico Inc.", marketCap: "241.46B" },
  ]);

  return (
    <div className="stock__portion">
      <h1 className="sidebar__main__heading__text"> Stocks</h1>
      <h1 className="sidebar__second__main__heading__text">
        Get Stats of all american stocks
      </h1>
      <p className="sidebar__paragraph">
        We will explain all the statistics using different charts and graphs
      </p>
      <span className="tickpoint one">
        <DoneIcon />
      </span>
      <span className="tickpoint two">
        <DoneIcon />
      </span>
      <span className="tickpoint three">
        <DoneIcon />
      </span>
      <span className="tickpoint four">
        <DoneIcon />
      </span>
      <span className="tickpoint five">
        <DoneIcon />
      </span>
      <p className="textpoint one">Real time data</p>
      <p className="textpoint two">Stock tickets</p>
      <p className="textpoint three">Stock history</p>
      <p className="textpoint four">Graphical representaion</p>
      <p className="textpoint five">Market caps</p>
      <div className="sidebar__btn">
        <span className="text" onClick={() => navigate("/All-Stocks")}>
          See All Stocks <ArrowForwardIcon />
        </span>
      </div>

      <div className="stocks__slider__container">
        <div className="shade "></div>
        <div className={`wrapper ${theme}`}>
          {/* <div className="rail__one"> */}

          {stocks?.map((s, i) => (
            <StockBox stock={s} />
          ))}

          {/* </div> */}
        </div>
      </div>
    </div>
  );
};

export default StocksPortion;

// import React, { useState, useEffect } from "react";
// import "../../Styles/HomeComponentsStyles/StocksPortion.css";
// import DoneIcon from "@mui/icons-material/Done";
// import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
// import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
// import { Carousel } from "react-responsive-carousel";

// const StocksPortion = () => {
//   const [amount, setAmount] = useState(18);
//   const [stocks, setStocks] = useState([]);
//   useEffect(() => {
//     let x = [];
//     for (let i = 0; i < amount; i++) {
//       x.push("1");
//     }
//     setStocks(x);
//   }, []);
//   return (
//     <div className="stock__portion">
//       <h1 className="sidebar__main__heading__text"> Stocks</h1>
//       <h1 className="sidebar__second__main__heading__text">
//         Get Stats Of All American Stocks.
//       </h1>
//       <p className="sidebar__paragraph">
//         We will explain all the statistics using different charts and graphs.
//       </p>
//       <span className="tickpoint one">
//         <DoneIcon />
//       </span>
//       <span className="tickpoint two">
//         <DoneIcon />
//       </span>
//       <span className="tickpoint three">
//         <DoneIcon />
//       </span>
//       <span className="tickpoint four">
//         <DoneIcon />
//       </span>
//       <span className="tickpoint five">
//         <DoneIcon />
//       </span>
//       <p className="textpoint one">Real time data</p>
//       <p className="textpoint two">Stock tickets</p>
//       <p className="textpoint three">Stock history</p>
//       <p className="textpoint four">Graphical representaion</p>
//       <p className="textpoint five">Market caps</p>
//       <div className="sidebar__btn">
//         <span className="text">
//           See All Stocks <ArrowForwardIcon />
//         </span>
//       </div>

//       <div className="stocks__slider__container">
//         <div className="wrapper">

//           {/* <div className="rail__one"> */}
//           {stocks?.map((s) => (
//             <div className="box">
//               <h5 className="heading">
//                 <span className="text">Twitter</span>
//               </h5>
//               <h6 className="subheading">
//                 <span className="text">Twitter.com</span>
//               </h6>
//               <div className="stock__price">
//                 <span className="text">$14,34</span>
//               </div>
//               <span className="logo"></span>
//               <div className="graph"></div>
//               <h5 className="market__cap">
//                 Market Cap: <b className="value">$12345 </b>
//               </h5>
//             </div>
//           ))}
//           {/* </div> */}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default StocksPortion;
